import styled from 'styled-components';

export const TabContainer = styled.div`
    & button {
        text-transform: initial;
        flex-direction: row;
        padding: 0 0 12px 0;
        margin: 0;
        min-width: 0;
        ${(props) => props.theme.typography.h3};
    }
`;
